import { gql } from '@apollo/client'
/**
 * GraphQL Query Aggregate .
 * @function GET_BILLER_DISCOVERY_QUERY
 * Returns the GraphQL query string .
 * @return  response data.
 */
/* E.g. {
    "appName":"BILLPAY",
    "billpayPayeeListInquiryRequest": 
    {
        "isCustomerConsentGiven" : true
    }
  }
} */

export const GET_BILLER_DISCOVERY_QUERY = gql`
  query potentialPayeeListInquiry(
    $appName: AppNameEnum
    $billpayPayeeListInquiryRequest: BillpayPayeeListInquiryRequest
  ) {
    potentialPayeeListInquiry(
      appName: $appName
      billpayPayeeListInquiryRequest: $billpayPayeeListInquiryRequest
    ) {
      payeeList {
        payeeId
        payeeAccountInfo {
          maskedaccountNumber
        }
        merchantData {
          billerName
          billerLogoUrl
          billerSiteUrl
        }
        verificationTokens {
          tokenDescription
          tokenValue
          tokenType
        }
        isAdditionalInfoRequired
      }
    }
  }
`
export default GET_BILLER_DISCOVERY_QUERY
